// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Table_table__Jtw-c {
    border-collapse: collapse;
    border-radius: 10px;
    max-width: 800px;
    
    background-color: #161c32; /* Темный цвет таблицы */
    color: #FFF;
    font-family: Arial, sans-serif;
    margin: 0 auto;
}
.Table_tableResponsive__LLz9I{
    overflow-x: auto;
}

@keyframes Table_fade-in__qR6pu {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}

.Table_fade__a8CHA {
    opacity: 0;
    animation: Table_fade-in__qR6pu 0.5s ease-in-out forwards;
}

tr {
    transition: background 1s ease;
    border-bottom: 1px solid #2C3845;
}

th, td {
    padding: 16px;
    text-align: center;
    vertical-align: middle;
}

td input {
    display: block;
    height: 40px;
    border: none;
    width: 100%;
    max-width: 350px;
    background-color: rgba(255, 255, 255, 0.07);
    border-radius: 10px;
    padding: 0 10px;
    font-size: 14px;
    font-weight: 300;
    color: white;
    box-sizing: border-box;
}

/* Media Queries for Responsiveness */
@media screen and (max-width: 800px) {
    th, td {
        padding: 12px;
        font-size: 14px;
    }
    
    td input {
        width: 100%;
        font-size: 13px;
    }
    .Table_table__Jtw-c{
        width: 100%;
        max-width: none;
        overflow-x: auto;
    }
    th, td {
        padding: 8px;
        font-size: 12px;
    }
    
    td input {
        height: 35px;
        font-size: 12px;
    }
    .Table_tableResponsive__LLz9I{
        width: 100%;
    }
    
}

@media screen and (max-width: 480px) {
    
}
`, "",{"version":3,"sources":["webpack://./src/components/UI/Table/Table.module.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;;IAEhB,yBAAyB,EAAE,wBAAwB;IACnD,WAAW;IACX,8BAA8B;IAC9B,cAAc;AAClB;AACA;IACI,gBAAgB;AACpB;;AAEA;IACI;QACI,UAAU;IACd;IACA;QACI,UAAU;IACd;AACJ;;AAEA;IACI,UAAU;IACV,yDAA4C;AAChD;;AAEA;IACI,8BAA8B;IAC9B,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB,2CAA2C;IAC3C,mBAAmB;IACnB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,sBAAsB;AAC1B;;AAEA,qCAAqC;AACrC;IACI;QACI,aAAa;QACb,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,eAAe;IACnB;IACA;QACI,WAAW;QACX,eAAe;QACf,gBAAgB;IACpB;IACA;QACI,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI,YAAY;QACZ,eAAe;IACnB;IACA;QACI,WAAW;IACf;;AAEJ;;AAEA;;AAEA","sourcesContent":[".table {\n    border-collapse: collapse;\n    border-radius: 10px;\n    max-width: 800px;\n    \n    background-color: #161c32; /* Темный цвет таблицы */\n    color: #FFF;\n    font-family: Arial, sans-serif;\n    margin: 0 auto;\n}\n.tableResponsive{\n    overflow-x: auto;\n}\n\n@keyframes fade-in {\n    from {\n        opacity: 0;\n    }\n    to {\n        opacity: 1;\n    }\n}\n\n.fade {\n    opacity: 0;\n    animation: fade-in 0.5s ease-in-out forwards;\n}\n\ntr {\n    transition: background 1s ease;\n    border-bottom: 1px solid #2C3845;\n}\n\nth, td {\n    padding: 16px;\n    text-align: center;\n    vertical-align: middle;\n}\n\ntd input {\n    display: block;\n    height: 40px;\n    border: none;\n    width: 100%;\n    max-width: 350px;\n    background-color: rgba(255, 255, 255, 0.07);\n    border-radius: 10px;\n    padding: 0 10px;\n    font-size: 14px;\n    font-weight: 300;\n    color: white;\n    box-sizing: border-box;\n}\n\n/* Media Queries for Responsiveness */\n@media screen and (max-width: 800px) {\n    th, td {\n        padding: 12px;\n        font-size: 14px;\n    }\n    \n    td input {\n        width: 100%;\n        font-size: 13px;\n    }\n    .table{\n        width: 100%;\n        max-width: none;\n        overflow-x: auto;\n    }\n    th, td {\n        padding: 8px;\n        font-size: 12px;\n    }\n    \n    td input {\n        height: 35px;\n        font-size: 12px;\n    }\n    .tableResponsive{\n        width: 100%;\n    }\n    \n}\n\n@media screen and (max-width: 480px) {\n    \n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"table": `Table_table__Jtw-c`,
	"tableResponsive": `Table_tableResponsive__LLz9I`,
	"fade": `Table_fade__a8CHA`,
	"fade-in": `Table_fade-in__qR6pu`
};
export default ___CSS_LOADER_EXPORT___;
